import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { SessionService, SessionUserData } from '../common/session.service';
import { ApiClient } from '../common/api-client.service';

interface User {
  email: string;
  current_password: string;
}

@Component({
  templateUrl: './email.component.html'
})
export class EmailSettingsComponent implements OnInit {
  user: User = {email: null, current_password: null};

  constructor(
    private apiClient: ApiClient,
    private session: SessionService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.apiClient.get<User>('/api/v1/user').toPromise().then(u => this.user = u);
  }

  save() {
    this.apiClient.patch<SessionUserData>('/api/v1/user', this.user).toPromise().then(user => {
      this.session.setUser(user)
      this.router.navigateByUrl('/account')
    }, resp => {
      // TODO
      alert(resp.error.errors);
    })
  }
}



// WEBPACK FOOTER //
// /srv/src/app/settings/email.component.ts